export default "__VITE_ASSET__b2780100__"